export default "__VITE_ASSET__D4UMDUkL__"